import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import SettingsPage from 'flarum/forum/components/SettingsPage';
import TextEditor from 'flarum/common/components/TextEditor';

export default () => {
  app.initializers.add('romansh/flarum-editor', app => {
    extend(SettingsPage.prototype, 'settingsItems', function (items) {
      items.remove('composer'); // editor settings are broken, so just remove them.
    });

    extend(TextEditor.prototype, 'buildEditor', function(editor) {
        /**
         * Editor's autocomplete often causing "Reply" postIds to be changed to a saved value,
         * causing the "Reply" to go to a different person entirely.
         */
        editor.view.dom.setAttribute('autocomplete', false);
        editor.view.dom.setAttribute('autofill', false);
        return editor;
    });
  });
};
